import type { IBillingSnapshot } from '../types';

/**
 * An org whose subscription ENDED (terminal snapshot kept for history) —
 * distinct from one that never subscribed (no plan payload at all). Drives
 * the ended-notice + catalog + invoices view on the billing page.
 */
export function isEndedSubscription(snapshot: IBillingSnapshot | undefined): boolean {
    return snapshot != null && snapshot.subscribed === false && snapshot.plan != null;
}

/**
 * A card-free trial that has run out (Phase D): either the SA's on-touch
 * deadline gate already flipped it to LOCKED (trial deadline, no grace
 * period — grace only exists for paid dunning), or the snapshot still says
 * TRIALING but the deadline is in the past (the flip is lazy). Nothing was
 * charged — there is no card — so the only next step is choosing a plan.
 */
export function isTrialExpiredSubscription(snapshot: IBillingSnapshot | undefined): boolean {
    const subscription = snapshot?.subscription;
    if (!subscription?.trialEndsAt) return false;
    if (subscription.status === 'LOCKED') return subscription.gracePeriodEndsAt == null;
    if (subscription.status !== 'TRIALING') return false;
    return Date.parse(subscription.trialEndsAt) <= Date.now();
}
